import { Vendors } from '../../../../api/api-vendors';
import * as types from '../constants/action-types';

const fetchVendorsRequest = () => {
  return {
    type: types.VENDORS_FETCH_REQUEST
  };
};

const fetchVendorsSuccess = (data) => {
  return {
    type: types.VENDORS_FETCH_SUCCESS,
    data
  };
};

const fetchVendorsFailure = (fetchError) => {
  return {
    type: types.VENDORS_FETCH_FAILURE,
    fetchError
  };
};

export const fetchOwnerVendorsInfo = (ssoId) => {
  return dispatch => {
    dispatch(fetchVendorsRequest());

    return Vendors.read(ssoId, (response) => {
      if (200 === response.statusCode) {
        return dispatch(fetchVendorsSuccess(response));
      }

      const fetchError = response.error;
      return dispatch(fetchVendorsFailure(fetchError));
    });
  };
};
